<template>
  <div class='tpc-base'>
    <header-base />
    <v-container fluid>
      <v-row wrap>
        <v-col cols='12' md='4'>
          <v-card>
            <v-card-title>Welcome to the Twisty Puzzle Cup!</v-card-title>
            <v-card-text style='text-align: left; color: #2c3e50;'>
              <div>
                <ul>
                <li>The Twisty Puzzle Cup is a multi-week event where competitors compete in different events to accrue points in each season's leaderboard. Events will be streamed on Twitch and <b>prizes will be awarded to the top 10 competitors of the season.</b></li>
                <li>Each event will start with <b>open qualifiers</b> and the best averages will make it into the bracket stage. Each bracket round will be a <b>head to head</b> best of 5 (unless stated otherwise). If you lose, you are knocked out of the bracket.</li>
                <li>If you don't make it into the bracket, make sure to stick around for the stream. We'll have <b>giveaways</b>, you can ask questions to some of the best cubers in the world during <b>competitor interview</b>, and there will be all sorts of fun besides just cubing.</li>
                </ul>
              </div>
              <br/>
              <h2>Prize Pool</h2>
              <div>
                Each segment has 4 events. You receive points based on the round that you were eliminated in. Find the up to date points distributions <a href='https://docs.google.com/document/d/1yNz0itnTNI1xHaxv9n0uS4J1pQRIdwl6ZosQD-Wk1Hk#heading=h.8zdhxd9f1coq' target='_blank'>here</a>.
                <h3>Segment 2 ($325)</h3>
                <b>$325</b> worth of SCS gift cards to be distributed amongst the top 10 competitors. Sponsored by SpeedCubeShop. Find the up to date prize distributions <a href='https://docs.google.com/document/d/1yNz0itnTNI1xHaxv9n0uS4J1pQRIdwl6ZosQD-Wk1Hk#heading=h.d7nnxgdmbi7d' target='_blank'>here</a>.
                <h3>Segment 3 onwards</h3>
                Coming soon...
              </div>
              <br/>
              <h2>Schedule</h2>
              <div style='padding-left: 12px;'>
                <v-row>
                  <v-col class='pa-0' cols='5'><b>July 10th</b></v-col>
                  <v-col class='pa-0' cols='7'><b>3x3, 4x4, 5x5, Skewb Qualifiers Open</b></v-col>
                </v-row>
                <v-row>
                  <v-col class='pa-0' cols='12'><b>Qualifiers close 36 hours before each bracket.</b></v-col>
                </v-row>
                <v-row>
                  <v-col class='pa-0' cols='5'>July 19th 2pm PDT</v-col>
                  <v-col class='pa-0' cols='7'>3x3 Bracket + <b>American Cancer Society</b> Fundraiser</v-col>
                </v-row>
                <v-row>
                  <v-col class='pa-0' cols='5'>July 25th 1pm PDT</v-col>
                  <v-col class='pa-0' cols='7'>4x4 Bracket</v-col>
                </v-row>
                <v-row>
                  <v-col class='pa-0' cols='5'>July 26th 3pm PDT</v-col>
                  <v-col class='pa-0' cols='7'>Skewb Bracket</v-col>
                </v-row>
                <v-row>
                  <v-col class='pa-0' cols='5'>August 1st 1pm PDT</v-col>
                  <v-col class='pa-0' cols='7'>5x5 Bracket</v-col>
                </v-row>
                <v-row>
                  <v-col class='pa-0' cols='12'><b>Segment 3 TBD</b></v-col>
                </v-row>
              </div>
              <br/>
              <h2>Links</h2>
              <div class='links'>
                <a href='https://discord.gg/BPz4VYQ'><v-icon color='#7289DA'>fab fa-discord</v-icon> Discord (FAQ, Announcements, Meet the Organizers and Competitors)</a><v-spacer/>
                <a href='https://www.twitch.tv/cuberslive'><v-icon color='#6441a5'>fab fa-twitch</v-icon> Twitch (Weekly Livestreams)</a><v-spacer/>
                <a href='https://www.youtube.com/channel/UCvraG0baqSBP6N1Qjc4a4_A'><v-icon color='#FF0000'>fab fa-youtube</v-icon> YouTube (Stream Highlights)</a><v-spacer/>
                <a href='https://www.facebook.com/CubersLive'><v-icon color='#4267B2'>fab fa-facebook</v-icon> Facebook</a><v-spacer/>
                <a href='https://www.instagram.com/cuberslive/'><v-icon color='#405DE6'>fab fa-instagram</v-icon> Instagram</a><v-spacer/>
                <a href='https://twitter.com/cuberslive'><v-icon color='#1DA1F2'>fab fa-twitter</v-icon> Twitter</a><v-spacer/>
              </div>
            </v-card-text>
          </v-card>
          <v-card>
            <v-card-title>Leaderboard (<router-link to='/tpc/hall-of-fame'><h4>Hall of Fame <v-icon color='primary' small>fas fa-external-link-alt</v-icon></h4></router-link>)</v-card-title>
            <points-ladder :seasonID='$route.query.seas || 1' :segmentID='$route.query.seg || 2' />
          </v-card>
        </v-col>
        <v-col cols='12' md='8'>
          <v-expansion-panels multiple focusable :value='popupVersion >= 2 ? [1,2] : [0,1,2]'> <!-- NOTE: increment popupVersion here -->
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon='fa-angle-down'><h1>Competitor Tutorial</h1></v-expansion-panel-header>
              <v-expansion-panel-content>
                <youtube videoId='NsCQJI2HinM' :playerWidth='playerScale * 640' :playerHeight='playerScale * 360'></youtube>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if='registeredRounds && registeredRounds.length > 0'>
              <v-expansion-panel-header expand-icon='fa-angle-down'><h1>Your Rounds</h1></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list expand>
                  <v-list-group v-for='rounds in registeredRoundsByStatus' :key='rounds.status' :value='rounds.active'>
                    <template v-slot:activator><v-list-item-content><v-list-item-title>{{ rounds.status }} <v-chip style='float: right; font-weight: 600;'>{{ rounds.rounds.length }}</v-chip></v-list-item-title></v-list-item-content></template>
                    <events-list-item v-for="(round, i) in rounds.rounds" :key='i' :id='round.roundid' :name='round.eventname' :type='round.type' roundType='REGISTERED' :status='round.status' :roundInfo='round' />
                  </v-list-group>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon='fa-angle-down'><h1>ONGOING</h1><h3>You might still be able to register if qualifiers are still open!</h3></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list v-if='ongoingEvents.length > 0'>
                  <events-list-item v-for='(event,i) in ongoingEvents' :key='i' :id='event.eventid' :name='event.eventname' :type='event.type' roundType='ONGOING' :status='event.qualstatus' />
                </v-list>
                <div v-else>No ongoing events</div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon='fa-angle-down'><h1>UPCOMING</h1></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list v-if='upcomingEvents.length > 0'>
                  <events-list-item v-for='(event,i) in upcomingEvents' :key='i' :id='event.eventid' :name='event.eventname' :type='event.type' roundType='UPCOMING' :status='event.qualstatus' />
                </v-list>
                <div v-else>No upcoming events</div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel @change='expandClosedEvents'>
              <v-expansion-panel-header expand-icon='fa-angle-down'><h1>CLOSED</h1></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list v-if='closedClicked && closedEvents.length > 0'>
                  <events-list-item v-for='(event,i) in closedEvents' :key='i' :id='event.eventid' :name='event.eventname' :type='event.type' roundType='CLOSED' />
                </v-list>
                <div v-else>No closed events</div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RoundsService from '@/services/TPC/RoundsService'

import EventsListItem from '@/components/TPC/EventsListItem'
import HeaderBase from '@/components/TPC/Header/Base'
import PointsLadder from '@/components/TPC/Shared/PointsLadder'

export default {
  name: 'tpc-base',
  components: {
    EventsListItem,
    HeaderBase,
    PointsLadder,
  },
  data () {
    return {
      registeredRounds: [],
      ongoingEvents: [],
      upcomingEvents: [],
      closedEvents: [],

      // check if closed events were loaded
      closedClicked: false,
    }
  },
  methods: {
    async expandClosedEvents () {
      if (this.closedClicked) return
      this.closedClicked = true
      let closedResp = await RoundsService.listEvents({eventStatus: 'CLOSED'})
      this.closedEvents = closedResp.data ? closedResp.data.events : []
    }
  },
  async created () {
    let ongoingResp = await RoundsService.listEvents({eventStatus: 'ONGOING'})
    this.ongoingEvents = ongoingResp.data ? ongoingResp.data.events : []
    let upcomingResp = await RoundsService.listEvents({eventStatus: 'UPCOMING'})
    this.upcomingEvents = upcomingResp.data ? upcomingResp.data.events : []

    let registeredResp = await RoundsService.getRegisteredRounds()
    this.registeredRounds = registeredResp.data ? registeredResp.data.rounds : []
  },
  computed: {
    registeredRoundsByStatus () {
      return [
        {status: 'OPEN', rounds: this.registeredRounds.filter(v => v.status === 'OPEN'), active: true},
        {status: 'REVIEW', rounds: this.registeredRounds.filter(v => v.status === 'REVIEW'), active: false},
        {status: 'UPCOMING', rounds: this.registeredRounds.filter(v => v.status === 'UPCOMING'), active: false},
        {status: 'CLOSED', rounds: this.registeredRounds.filter(v => v.status === 'CLOSED'), active: false},
      ]
    },
    popupVersion () {
      // for highlights popup
      let v = localStorage.getItem('tpcBasePopup')
      localStorage.setItem('tpcBasePopup', 2) // NOTE: increment popupVersion here
      return parseInt(v || 0)
    },
    playerScale () {
      return window.innerWidth < 730 ? window.innerWidth / 800.0 : 1.0
    },
  }
}
</script>

<style scoped>
.v-list-item__content {
  text-align: left;
}
.links > a {
  text-decoration: none;
}
@media (min-width: 1904px) {
  .container {
    max-width: 1785px !important;
  }
}
</style>
